var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievementsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0;}\n\t.st1{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 500,
    height: 500
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M334.1,488.8c-2.7,0-5.3-0.8-7.5-2.3L250,435.4l-76.6,51.1c-6.2,4.1-14.6,2.4-18.7-3.8c-1.5-2.2-2.3-4.8-2.3-7.5v-129 l-0.2-0.1C99.8,312.8,68.2,255,68.2,193C68.2,92.8,149.8,11.2,250,11.2S431.8,92.8,431.8,193c0.1,62-31.6,119.8-83.9,153.1l-0.2,0.1 v129C347.6,482.7,341.6,488.8,334.1,488.8L334.1,488.8z M179.4,450l63.1-42.1c4.5-3,10.5-3,15,0l63.1,42.1v-89.5l-0.7,0.3 c-44.7,18.7-95.1,18.7-139.8,0l-0.7-0.3L179.4,450z M250,38.3c-85.3,0-154.7,69.4-154.7,154.8S164.7,347.7,250,347.7 S404.7,278.3,404.7,193S335.3,38.3,250,38.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M310.7,290.6c-2.1,0-4.3-0.5-6.2-1.5l-54.5-28l-54.5,28c-1.9,1-4,1.5-6.2,1.5c-7.5,0-13.5-6-13.5-13.5 c0-0.8,0.1-1.6,0.2-2.3l10.4-58.8l-43.8-41.7c-5.4-5.1-5.7-13.7-0.5-19.1c2.1-2.2,4.9-3.7,8-4.1l60.8-8.6L238,88.7 c3.4-6.7,11.5-9.3,18.2-6c2.6,1.3,4.7,3.4,6,6l27.1,53.7l60.8,8.6c7.4,1,12.5,7.9,11.5,15.3c-0.4,3-1.9,5.8-4.1,7.9L313.6,216 l10.4,58.8c1.3,7.4-3.6,14.4-11,15.7C312.2,290.6,311.5,290.6,310.7,290.6L310.7,290.6z M250,232.4c2.1,0,4.3,0.5,6.2,1.5l36.5,18.7 l-6.9-39.2c-0.8-4.5,0.7-9,4-12.1l28.8-27.4l-40.2-5.7c-4.4-0.6-8.2-3.3-10.2-7.3L250,124.8l-18.3,36.1c-2,3.9-5.8,6.7-10.2,7.3 l-40.2,5.7l28.8,27.4c3.3,3.1,4.8,7.7,4,12.1l-6.9,39.2l36.5-18.7C245.7,233,247.9,232.5,250,232.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementsDark);
export default __webpack_public_path__ + "static/media/achievements_dark.2ac704786ae02af62347545aca7324b3.svg";
export { ForwardRef as ReactComponent };